import qs from 'query-string';

const url = URL;
const { parse, stringify } = qs;
const defaults = {
  redirectQueryParamName: 'redirect',
  locationSelector: () => window.location,
};

export const locationHelperBuilder = (args: any) => {
  const { redirectQueryParamName, locationSelector } = {
    ...defaults,
    ...args,
  };

  const getRedirectQueryParam = () => {
    const location = locationSelector();
    const query = parse(location.search);
    return query[redirectQueryParamName];
  };

  const createRedirectLoc = (redirectPath: any, allowRedirectBack = true) => {
    const location = locationSelector();
    const redirectLoc = url.parse(redirectPath, window.location as any);

    let query: Record<string, string> | undefined;

    if (allowRedirectBack) {
      query = {
        [redirectQueryParamName]: `${location.pathname}${location.search}${location.hash}`,
      };
    } else {
      query = {};
    }

    return {
      pathname: redirectLoc?.pathname,
      hash: redirectLoc?.hash,
      search: stringify(query),
    };
  };

  return {
    getRedirectQueryParam,
    createRedirectLoc,
  };
};
